import {
    faArrowsRotate,
    faEllipsisVertical,
    faTrash,
    faUpRightAndDownLeftFromCenter,
} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Dropdown, Image, MenuProps} from 'antd';
import classNames from 'classnames';
import {useState} from 'react';

import {Spinner} from '../../../../../../../../../layout/spinner/spinner';
import {Locale} from '../../../../../../../../../provider/locale/localization';
import {PostAiGeneratedImageType} from '../../../../../../../../../service/posts/posts-types';

import * as styles from './generation-image-card.scss';

type PropsType = {
    image: PostAiGeneratedImageType | null;
    isRegenerating: boolean;
    onRegenerate: () => void;
    onDelete: () => void;
};

export function GenerationImageCard(props: PropsType): JSX.Element {
    const {image, isRegenerating, onRegenerate, onDelete} = props;

    const [isPreviewVisible, setIsPreviewVisible] = useState<boolean>(false);

    if (isRegenerating) {
        return (
            <div className={classNames(styles.GenerationImageCard, styles.GenerationImageCard__placeholder)}>
                <Spinner />
            </div>
        );
    }

    if (!image) {
        return (
            <button
                className={classNames(styles.GenerationImageCard, styles.GenerationImageCard__empty)}
                onClick={onRegenerate}
                type="button"
            >
                <FontAwesomeIcon icon={faArrowsRotate} />
                <Locale stringKey="POSTS_AI_GENERATION__IMAGE__REGENERATE" />
            </button>
        );
    }

    const menuItems: MenuProps['items'] = [
        {
            key: 'expand',
            icon: <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />,
            label: <Locale stringKey="POSTS_AI_GENERATION__IMAGE__EXPAND" />,
        },
        {
            key: 'regenerate',
            icon: <FontAwesomeIcon icon={faArrowsRotate} />,
            label: <Locale stringKey="POSTS_AI_GENERATION__IMAGE__REGENERATE" />,
        },
        {
            key: 'delete',
            icon: <FontAwesomeIcon icon={faTrash} />,
            label: <Locale stringKey="POSTS_AI_GENERATION__IMAGE__DELETE" />,
        },
    ];

    function onMenuClick({key}: Parameters<NonNullable<MenuProps['onClick']>>[0]): void {
        switch (key) {
            case 'expand': {
                setIsPreviewVisible(true);

                break;
            }
            case 'regenerate': {
                onRegenerate();

                break;
            }
            case 'delete': {
                onDelete();

                break;
            }
            // No default
        }
    }

    return (
        <div className={styles.GenerationImageCard}>
            <Image
                className={styles.GenerationImageCard_image}
                preview={{visible: isPreviewVisible, onVisibleChange: setIsPreviewVisible}}
                src={image.url}
            />

            <Dropdown menu={{items: menuItems, onClick: onMenuClick}} placement="bottomRight" trigger={['click']}>
                <button className={styles.GenerationImageCard_menuButton} type="button">
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                </button>
            </Dropdown>
        </div>
    );
}
